// *************** STOREFRONT API *******************

import {
  getDiscountCode,
  getDiscountCodeList,
  getFilterOptions,
  getFilters,
  getStore,
  validQueryParamFiltersFactory
} from './storeEndpoint'
import { login, resendMagicLink, resetPassword, setPassword, signup } from './authEndpoint'
import { findById, getCustomerOrderItems, getCustomerOrders, update } from './customerEndpoint'
import {
  checkoutRelatedProducts,
  getMarketplaceProducts,
  listProducts,
  listProductsFull,
  productById,
  productBySlug,
  productSlugs,
  searchProducts,
  searchProductsAutocomplete,
  variantsByGroupId
} from './productsEndpoint'
import {
  createStorefrontOrder,
  getStorefrontOrderByOrderNumber,
  provisionOrder,
  updateStorefrontOrder
} from './ordersEndpoint'
import {
  createInvoiceOrder,
  getInvoiceOrderByOrderNumber,
  updateInvoiceOrder,
  updateInvoiceOrderStatus
} from './invoiceOrdersEndpoint'
import { widgetApi } from './widgetEndpoint'
import { getAssistantChatResponse } from './assistantEndpoint'
import {
  getAssistantV2ChatResponse,
  getAssistantV2Thread,
  textToSpeech
} from './assistantV2Endpoint'
import { aiOfferApi } from './aiOfferApi'

const storefrontApi = {
  auth: {
    login,
    setPassword,
    resetPassword,
    resendMagicLink,
    signup
  },

  customer: {
    findById,
    update,
    getCustomerOrders,
    getCustomerOrderItems
  },

  store: {
    getStore,
    getFilters,
    getDiscountCode,
    getDiscountCodeList,
    getFilterOptions,
    validQueryParamFiltersFactory
  },
  products: {
    searchProducts,
    searchProductsAutocomplete,
    listProducts,
    listProductsFull,
    productById,
    productBySlug,
    productSlugs,
    variantsByGroupId,
    checkoutRelatedProducts,
    getMarketplaceProducts
  },
  orders: {
    createStorefrontOrder,
    updateStorefrontOrder,
    getStorefrontOrder: getStorefrontOrderByOrderNumber,
    provisionOrder
  },
  invoiceOrders: {
    createInvoiceOrder,
    updateInvoiceOrder,
    getInvoiceOrder: getInvoiceOrderByOrderNumber,
    updateInvoiceOrderStatus
  },
  widgets: widgetApi,
  assistant: {
    getAssistantChatResponse
  },
  assistantV2: {
    getAssistantV2Thread,
    getAssistantV2ChatResponse,
    textToSpeech
  },
  aiOffer: aiOfferApi
}

export default storefrontApi
